/* BOBBO measurement v1. Pure timing logic; no network, cookies or DOM access. */
(function (root, factory) {
  const api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  else root.BobboMeasurementCore = api;
})(typeof globalThis === "object" ? globalThis : this, function () {
  "use strict";
  function explicitAnalyticsConsent(privacy) {
    try {
      return (
        privacy?.currentVisitorConsent?.().analytics === "yes" &&
        privacy?.analyticsProcessingAllowed?.() === true
      );
    } catch (_) {
      return false;
    }
  }
  function isQualified(rect, viewportHeight, viewportWidth, displayed = true) {
    if (
      !displayed ||
      !rect ||
      rect.height <= 0 ||
      viewportHeight <= 0 ||
      rect.right <= 0 ||
      rect.left >= viewportWidth
    )
      return false;
    const visible = Math.max(
      0,
      Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0),
    );
    return visible >= Math.min(rect.height, viewportHeight) * 0.5;
  }
  class ExposureMeter {
    constructor() {
      this.reset();
    }
    reset() {
      this.last = null;
      this.active = false;
      this.run = 0;
      this.viewed = false;
      this.pending = 0;
      this.sequence = 0;
    }
    sample(now, qualified) {
      let delta = this.last === null ? 0 : Math.max(0, now - this.last);
      // Sampling cadence is 250ms. Suspended timers/bfcache must not add minutes.
      if (delta > 2000) {
        delta = 0;
        this.run = 0;
      }
      this.last = now;
      let newView = false;
      if (this.active) {
        if (this.viewed) this.pending += delta;
        else if (qualified) {
          this.run += delta;
          if (this.run >= 1000) {
            this.viewed = true;
            this.pending += this.run;
            newView = true;
          }
        }
      }
      if (!qualified) this.run = 0;
      this.active = !!qualified;
      return newView;
    }
    flush() {
      const delta = Math.floor(this.pending);
      if (!this.viewed || delta <= 0) return null;
      this.pending -= delta;
      return { visible_ms_delta: delta, sequence: ++this.sequence };
    }
  }
  const OPTIONS = {
    color: ["Blush Pink", "Sky Blue", "Warm Cream"],
    material: ["Stainless Steel", "Ceramic"],
    ai_plan: ["2-Month AI Included", "1-Year AI Included"],
    format: ["framed", "replacement"],
    artwork: [
      "Water Shimmer",
      "Leaf Boat",
      "Window Light",
      "Red Fruit",
      "Sunny Field",
      "Forest Light",
    ],
  };
  function optionValue(type, value) {
    return Object.hasOwn(OPTIONS, type) && OPTIONS[type].includes(value)
      ? value.toLowerCase().replace(/[^a-z0-9]+/g, "_")
      : null;
  }
  function cartError(status) {
    if (status === 0) return "network";
    if (status === 422) return "inventory_or_validation";
    if (status === 429) return "rate_limited";
    if (status >= 500) return "server";
    if (status >= 400) return "request";
    return null;
  }
  class VideoMeter {
    constructor() {
      this.reset();
    }
    reset() {
      this.previous = null;
      this.ranges = [];
      this.sent = new Set();
    }
    sample({ time, position, duration, active, seeking = false, rate = 1 }) {
      if (
        !Number.isFinite(duration) ||
        duration <= 0 ||
        !Number.isFinite(position) ||
        !Number.isFinite(time)
      )
        return [];
      const current = {
        time,
        position: Math.max(0, Math.min(position, duration)),
        active: !!active && !seeking,
      };
      const last = this.previous;
      this.previous = current;
      if (!current.active) return [];
      const out = [];
      if (!this.sent.has(0)) {
        this.sent.add(0);
        out.push(0);
      }
      if (last?.active) {
        const wall = (time - last.time) / 1000,
          delta = current.position - last.position;
        if (
          wall > 0 &&
          wall <= 2 &&
          delta > 0 &&
          delta <= wall * Math.max(0.1, Math.min(rate, 4)) + 0.2
        ) {
          this.ranges.push([last.position, current.position]);
          this.ranges.sort((a, b) => a[0] - b[0]);
          const merged = [];
          for (const range of this.ranges) {
            const tail = merged.at(-1);
            if (tail && range[0] <= tail[1])
              tail[1] = Math.max(tail[1], range[1]);
            else merged.push([...range]);
          }
          // Bound pathological seeking; dropping coverage undercounts, never fabricates it.
          this.ranges = merged.slice(0, 512);
        }
      }
      const covered = this.ranges.reduce((sum, [a, b]) => sum + b - a, 0);
      for (const mark of [25, 50, 75, 100])
        if (
          !this.sent.has(mark) &&
          covered >= (duration * mark) / 100 - 0.001
        ) {
          this.sent.add(mark);
          out.push(mark);
        }
      return out;
    }
  }
  return {
    ExposureMeter,
    VideoMeter,
    optionValue,
    cartError,
    isQualified,
    explicitAnalyticsConsent,
  };
});
